// extracted by mini-css-extract-plugin
module.exports = {"heading":"i_Hk","container":"i_Hl"};